import React from 'react';

interface LabelProps {
    text: string;
    classname: string;
}

const Label: React.FC<LabelProps> = ({ text, classname }) => {
    return (
        <span className={classname}>{text}</span>
    );
};

export default Label;